import { render, staticRenderFns } from "./AddFacilityModal.vue?vue&type=template&id=b88f9a8c&"
import script from "./AddFacilityModal.vue?vue&type=script&lang=ts&"
export * from "./AddFacilityModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports